import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const agentThemes = {
  'gap_navigator': {
    name: 'Gap Navigator',
    description: 'Specialist in career gap analysis and remediation',
    primary: '#8B5CF6',
    primaryHover: '#7C3AED',
    bg: '#F3F4F6',
    border: '#C4B5FD',
    text: '#581C87',
    accent: '#EDE9FE'
  },
  'personal_advocate': {
    name: 'Personal Advocate',
    description: 'Your personal career champion and supporter',
    primary: '#DC2626',
    primaryHover: '#B91C1C',
    bg: '#FEF2F2',
    border: '#FECACA',
    text: '#991B1B',
    accent: '#FEE2E2'
  },
  'resume_navigator': {
    name: 'Resume Navigator',
    description: 'Expert resume editor with precision text editing',
    primary: '#3B82F6',
    primaryHover: '#2563EB',
    bg: '#EFF6FF',
    border: '#BFDBFE',
    text: '#1E3A8A',
    accent: '#DBEAFE'
  }
} as const

export type AgentId = keyof typeof agentThemes

export function getAgentName(agentId: string): string {
  return agentThemes[agentId as AgentId]?.name || 'Agent'
}

export function setAgentTheme(agentId?: string) {
  // The data-agent attribute drives the --agent token tints (src/index.css §3)
  if (agentId && agentId in agentThemes) {
    document.documentElement.setAttribute('data-agent', agentId);
  } else {
    document.documentElement.removeAttribute('data-agent');
  }
}

export function setTheme(theme: 'light' | 'dark') {
  document.documentElement.setAttribute('data-theme', theme)
}

// Agent-specific utilities
export function getAgentTheme(agentId: string) {
  return agentThemes[agentId as AgentId];
}
